import { useEffect, useRef, useState } from 'react';

import { ContentTypeRouteService } from '../../entry-points/content-types-route-service';

export const useRouteService = (url: string) => {
	const [routeService] = useState(() => new ContentTypeRouteService());
	const initialRender = useRef(true);

	useEffect(() => {
		if (!initialRender.current) {
			routeService.updateRoute(url);
		}
		initialRender.current = false;
	}, [routeService, url]);

	return routeService;
};
